import { COLORS } from '@btime/constants'
import { propEq } from 'ramda'
import React, { useMemo } from 'react'

import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../components/pdf/TableHelpers'
import Text from '../../../../components/pdf/Text'
import Image from '../../../../components/pdf/Image'
import Separator from '../../../../components/pdf/Separator'
import { formatPercentNumber, getConclusion } from '../_helpers/pdfHelpers'

const PointsTableWithImage = ({ image, sections, title, furnitureType, setor, tipo }) => {
  const sectionsSize = sections.length
  const allRows = sections.reduce((rows, section) => [...rows, ...section.rows], [])
  const rowsSize = allRows.length

  const truePoints = allRows.filter(propEq('value', true)).length
  const falsePoints = allRows.filter(propEq('value', false)).length
  const nullPoints = allRows.filter(propEq('value', null)).length
  const truePercentage = formatPercentNumber((truePoints / (truePoints + falsePoints)) * 100)

  const resume = useMemo(() => {
    return getConclusion(truePercentage, tipo)
  }, [truePercentage, tipo])

  return (
    <>
      <Table width="100%">
        <TableRow>
          {setor && (
            <TableColText bold align="center" size="small">
              {setor}
            </TableColText>
          )}
          {furnitureType && (
            <TableColText bold align="center" size="small" colSpan={4}>
              {furnitureType}
            </TableColText>
          )}
        </TableRow>

        {sections.map((section, sectionIndex) => (
          <>
            <TableRow key={sectionIndex}>
              {sectionIndex === 0 && (
                <TableHeadText width="220px" align="center">
                  {title}
                </TableHeadText>
              )}
              <TableHeadText>{section.label}</TableHeadText>
              <TableHeadText align="center">Sim</TableHeadText>
              <TableHeadText align="center">Não</TableHeadText>
              <TableHeadText align="center">N/A</TableHeadText>
            </TableRow>

            {section.rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {sectionIndex === 0 && rowIndex === 0 && (
                  <TableCol rowSpan={sectionsSize + rowsSize - 1}>
                    <Image src={image} ignoreFixedSize />
                  </TableCol>
                )}
                <TableColText>{row.label}</TableColText>
                <TableColText align="center">{row.value === true ? 'X' : ''}</TableColText>
                <TableColText align="center">{row.value === false ? 'X' : ''}</TableColText>
                <TableColText align="center">{row.value === null ? 'X' : ''}</TableColText>
              </TableRow>
            ))}
          </>
        ))}

        <TableRow>
          <TableHeadText>Classificação de Adequação</TableHeadText>
          <TableHeadText align="right" rowSpan={3}>
            Soma dos pontos:
          </TableHeadText>
          <TableHeadText align="center" rowSpan={3} bgColor={COLORS.lightGreen}>
            {truePoints}
          </TableHeadText>
          <TableHeadText align="center" rowSpan={3} bgColor={COLORS.lightRed}>
            {falsePoints}
          </TableHeadText>
          <TableHeadText align="center" rowSpan={3}>
            {nullPoints}
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableColText bgColor={COLORS.lightGreen}>91 a 100% dos pontos - condição ergonômica excelente</TableColText>
        </TableRow>

        <TableRow>
          <TableColText bgColor={COLORS.lightGreen}>71 a 90% dos pontos - condição ergonômica boa</TableColText>
        </TableRow>

        <TableRow>
          <TableColText bgColor={COLORS.yellow}>51 a 70% dos pontos - condição ergonômica razoável</TableColText>
          <TableHeadText align="right" rowSpan={4}>
            Classificação de adequação (%):
          </TableHeadText>
          <TableHeadText align="center" rowSpan={4} colSpan={3} bgColor={COLORS.lightGreen}>
            {truePercentage}%
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableColText bgColor={COLORS.lightRed}>31 a 50% dos pontos - condição ergonômica ruim</TableColText>
        </TableRow>

        <TableRow>
          <TableColText bgColor={COLORS.lightRed}>Inferior a 31% - condição ergonômica péssima</TableColText>
        </TableRow>
      </Table>

      {resume && (
        <>
          <Text bold size="small">
            CONCLUSÃO / AÇÃO DE ERGONOMIA
          </Text>
          <ul style={{ marginTop: '0rem' }}>
            <li>
              <Text underlineColor={COLORS.lightGreen}>{resume}</Text>
            </li>
          </ul>
        </>
      )}
      <Separator weight={8} />
    </>
  )
}

export default PointsTableWithImage
